import { Modal, Text } from "@mantine/core";

interface SuccessModalProps {
  opened: boolean;
  onClose: () => void;
  message: string;
}

/**
 * Simple success modal that displays a message.
 */
const SuccessModal = ({ opened, onClose, message }: SuccessModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      centered
      size="sm"
    >
      <Text size="lg" fw={500} ta="center" py="xl">
        {message}
      </Text>
    </Modal>
  );
};

export default SuccessModal;
